export default "__VITE_ASSET__lwpdvGYE__"